import * as React from 'react';
type Props = {
  className?: string;
};
export function StarOutline({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-star-outline"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3L14.7812 8.92523L21 9.87539L16.5 14.4875L17.5623 21L12 17.9252L6.43769 21L7.5 14.4875L3 9.87539L9.21885 8.92523L12 3ZM13.4368 10.7683L11.9999 7.707L10.563 10.7683L7.149 11.2894L9.62579 13.8278L9.06168 17.2828L11.9999 15.659L14.9373 17.2828L14.374 13.8278L16.85 11.2894L13.4368 10.7683Z"
        fill="currentColor"
      />
    </svg>
  );
}
